export function safeNextPath(value, fallback = "/profile") {
  if (!value || typeof value !== "string") return fallback;
  if (!value.startsWith("/") || value.startsWith("//") || value.startsWith("/login")) {
    return fallback;
  }
  return value;
}

export function loginPathWithNext(pathname, search = "") {
  const next = encodeURIComponent(`${pathname}${search || ""}`);
  return `/login?next=${next}`;
}
